module.exports = __webpack_public_path__ + "static/s-1-1b0b3205e0541e6302f25d68e20de340.svg";